import client from "./axiosConfig";

// Task Master APIs
export const getTaskMasters = (params) => {
  const config = {
    url: "/tasks/master/",
    method: "GET",
    params,
  };
  const response = client(config);
  return response;
};

export const getTaskMasterDetails = (id) => {
  const config = {
    url: `/tasks/master/${id}/`,
    method: "GET",
  };
  const response = client(config);
  return response;
};

export const postTaskMaster = (data) => {
  const config = {
    url: "/tasks/master/",
    method: "POST",
    data,
  };
  const response = client(config);
  return response;
};

export const updateTaskMaster = (data) => {
  const config = {
    url: `/tasks/master/${data.id}/`, // id is part of data
    method: "PATCH",
    data,
  };
  const response = client(config);
  return response;
};

export const deleteTaskMaster = (id) => {
  const config = {
    url: `/tasks/master/${id}/`,
    method: "DELETE",
  };
  const response = client(config);
  return response;
};

// Sub-tasks APIs
export const getSubTasks = (masterId, params) => {
  const config = {
    url: `/tasks/master/${masterId}/subtask/`,
    method: "GET",
    params,
  };
  const response = client(config);
  return response;
}

export const postSubTask = (masterId, data) => {
  const config = {
    url: `/tasks/master/${masterId}/subtask/`, 
    method: "POST",
    data,
  };
  const response = client(config);
  return response;
};

export const updateSubTask = (masterId, subTaskId, data) => {
  const config = {
    url: `/tasks/master/${masterId}/subtask/${subTaskId}/`, 
    method: "PATCH",
    data,
  };
  const response = client(config);
  return response;
}

export const deleteSubTask = (masterId, subTaskId) => {
  const config = {
    url: `/tasks/master/${masterId}/subtask/${subTaskId}/`,
    method: "DELETE",
  };
  const response = client(config);
  return response;
}
